import * as React from 'react';
import { SVGProps } from 'react';
const SvgIcSheet = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M20.828 2 27 7.555V30H5V2h15.828ZM19 4H7v24h18V10h-6V4Zm5.506 4L21 4.845V8h3.506Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);
export default SvgIcSheet;
